"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Footer = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRedux = require("react-redux");

var _actions = require("../store/actions");

var _styles = _interopRequireDefault(require("../styles"));

var _Style = _interopRequireDefault(require("./Style"));

var _constants = require("../constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function getFooterItemData(env) {
  var prefix = env === _constants.ENV_STRINGS.prod ? '' : "".concat(env, "-");
  var baseUrl = "https://www.".concat(prefix, "godaddy.com");
  return [{
    id: 'how-to',
    title: 'How-To',
    subtitle: 'GoDaddy Guides show you how to get your online venture up and thriving',
    url: "".concat(baseUrl, "/how-to")
  }, {
    id: 'community',
    title: 'Community',
    subtitle: 'Connect and share information and ideas so you can succeed online',
    url: "".concat(baseUrl, "/community")
  }, {
    id: 'blog',
    title: 'Blog',
    subtitle: 'Tips and inspiration to empower you on your entrepreneur journey',
    url: "".concat(baseUrl, "/garage")
  }];
}

var FooterItem = function FooterItem(_ref) {
  var onClick = _ref.onClick,
      subtitle = _ref.subtitle,
      title = _ref.title,
      url = _ref.url;
  return _react.default.createElement("div", {
    className: "help--footer-item-container"
  }, _react.default.createElement("div", null, _react.default.createElement("a", {
    className: "help--footer-item-link",
    href: url,
    target: "_blank",
    rel: "noopener noreferrer",
    onClick: onClick
  }, title)), _react.default.createElement("div", null, subtitle));
};

FooterItem.propTypes = {
  id: _propTypes.default.string,
  onClick: _propTypes.default.func,
  subtitle: _propTypes.default.string,
  title: _propTypes.default.string,
  url: _propTypes.default.string
};

var Footer =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Footer, _PureComponent);

  function Footer() {
    _classCallCheck(this, Footer);

    return _possibleConstructorReturn(this, _getPrototypeOf(Footer).apply(this, arguments));
  }

  _createClass(Footer, [{
    key: "render",
    value: function render() {
      var _this = this;

      var _this$props = this.props,
          market = _this$props.market,
          env = _this$props.env;
      var footerItemsData = getFooterItemData(env);
      return market === _constants.MARKET_EN_US ? _react.default.createElement(_react.Fragment, null, _react.default.createElement("div", {
        className: "help--footer-container"
      }, _react.default.createElement("div", {
        className: "help--footer-title"
      }, 'Want to know more?'), footerItemsData.map(function (item) {
        return _react.default.createElement(FooterItem, _extends({
          key: item.id,
          onClick: function onClick() {
            return _this.props.trafficFooterClick({
              name: item.id
            });
          }
        }, item));
      }), _react.default.createElement("div", {
        className: "help--footer-bottom-bar"
      })), _react.default.createElement(_Style.default, {
        css: "\n            .help--footer-container {\n              background-color: ".concat(_styles.default.colors.grayFaint, ";\n              padding: 1.5em;\n              padding-bottom: 2em;\n              position: relative;\n            }\n\n            .help--footer-title {\n              font-family: ").concat(_styles.default.fonts.gdsage, ";\n              font-weight: 700;\n              font-size: 1.4em;\n            }\n\n            .help--footer-item-container {\n              margin-top: 1em;\n            }\n\n            .help--footer-item-link {\n              text-decoration: none;\n            }\n\n            .help--footer-bottom-bar {\n              background-color: ").concat(_styles.default.colors.blue, ";\n              background-image: linear-gradient(45deg, ").concat(_styles.default.colors.blue, ", ").concat(_styles.default.colors.purple, ");\n              bottom: 0;\n              height: 7px;\n              left: 0;\n              position: absolute;\n              width: 100%;\n            }\n          ")
      })) : null;
    }
  }]);

  return Footer;
}(_react.PureComponent);

exports.Footer = Footer;
Footer.propTypes = {
  env: _propTypes.default.string,
  market: _propTypes.default.string,
  trafficFooterClick: _propTypes.default.func.isRequired
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    env: state.app.env,
    market: state.app.market
  };
};

var mapDispatchToProps = {
  trafficFooterClick: _actions.trafficFooterClick
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Footer);

exports.default = _default;